import React from 'react';

/**
 * Circular person avatar with deterministic color from name/email.
 * No photos, only a warm token tint plus initials.
 */

const AVATAR_COLOR_TOKENS = [
  'var(--warning)',
  'var(--error)',
  'var(--signal-insight)',
  'var(--success)',
  'var(--priority-3)',
  'var(--signal-rose)',
  'var(--cat-transaction)',
  'var(--cat-notif)',
];

function hashColor(seed: string): string {
  let n = 0;
  for (let i = 0; i < seed.length; i++) n = (n * 31 + seed.charCodeAt(i)) >>> 0;
  return AVATAR_COLOR_TOKENS[n % AVATAR_COLOR_TOKENS.length]!;
}

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).slice(0, 2);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return (parts[0]![0]! + parts[1]![0]!).toUpperCase();
}

export interface PersonAvatarProps {
  name: string;
  email?: string;
  size?: number;
}

export function PersonAvatar({ name, email, size = 28 }: PersonAvatarProps) {
  const seed = email ?? name;
  const bg = hashColor(seed);
  return (
    <span
      aria-hidden
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: bg,
        color: 'var(--on-accent)',
        fontSize: size * 0.42,
        fontWeight: 500,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        fontFamily: 'var(--font-ui)',
        letterSpacing: 0,
      }}
    >
      {initials(name)}
    </span>
  );
}
